<script>
    import { createEventDispatcher } from "svelte";
    import DTInputCell from "../common/DTInputCell.svelte";
    import Checkbox from "@smui/checkbox";
    import Tooltip, { Wrapper, Content } from "@smui/tooltip";
    import { mdiCheckboxOutline, mdiCheckboxBlankOutline } from "@mdi/js";
    import { _ } from "svelte-i18n";
    import { formatVolume, isNumber } from "../lib/Functions";

    export let row = {};
    export let disabled = false;

    const dispatch = createEventDispatcher();

    // Tooltip positioning
    let tooltipXpos = 0;
    let tooltipYpos = 0;

    $: checked = row.d1Promo * row.d2Promo * row.d3Promo * row.d4Promo * row.d5Promo * row.d6Promo * row.d7Promo == 1;

    function handleFocusOrHover(event) {
        const el = event.detail?.element || event.currentTarget;
        if (!el) return;

        const rect = el.getBoundingClientRect();
        tooltipXpos = rect.left;
        tooltipYpos = rect.top + rect.height;
    }

</script>

<Wrapper rich style="position: unset !important; --tooltip-top: {tooltipYpos}px; --tooltip-left: {tooltipXpos}px">
    <div class="datatable-cell align-center {checked && !disabled ? 'yellow' : ''}">
            <Checkbox
                on:focusin={handleFocusOrHover}
                on:mouseenter={handleFocusOrHover}
                bind:checked={checked}
                disabled={disabled}
                on:click={() => {
                    dispatch("promoFlagChange",{row: row, checked: checked});
                }}
                aria-label="Promotion price checkbox"
            />

            <!-- Tooltip -->
            <Tooltip style="position: fixed !important; left: calc(var(--tooltip-left)) !important; top: var(--tooltip-top) !important;" surface$style="max-width: max-content">
                <Content style="max-width: fit-content;">
                        <strong>{$_("set_promo_for_whole_week")}:</strong>
                </Content>
            </Tooltip>

    </div>

</Wrapper>

<style>
    .datatable-cell {
        display: flex;
        align-items: center;
    }
    .align-center {
        vertical-align: middle;
        display: flex;
        flex-direction: column;
        flex: 1;
        justify-content: center;
    }

</style>